export const PAGE_SIZES = [20, 50, 100];

export function Pagination({ page, totalPages, pageSize, totalCount, onPage, onPageSize }) {
  if (!totalCount) return null;

  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push('…');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push('…');
    pages.push(totalPages);
  }

  const start = (page - 1) * pageSize + 1;
  const end   = Math.min(page * pageSize, totalCount);

  return (
    <div className="pagination">
      <div className="pagination-info">Showing {start}–{end} of {totalCount}</div>

      <div className="pagination-controls">
        <button className="pg-btn" onClick={() => onPage(page - 1)} disabled={page <= 1}>‹</button>
        {pages.map((p, i) =>
          p === '…'
            ? <span key={`e${i}`} className="pg-btn pg-ellipsis">…</span>
            : <button key={p} className={`pg-btn${page === p ? ' active' : ''}`} onClick={() => onPage(p)}>{p}</button>
        )}
        <button className="pg-btn" onClick={() => onPage(page + 1)} disabled={page >= totalPages}>›</button>
      </div>

      <div className="pg-size">
        Rows:
        <select value={pageSize} onChange={e => onPageSize(Number(e.target.value))}>
          {PAGE_SIZES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
    </div>
  );
}
